import { useTranslation } from "react-i18next";
import ImageContent from "../dynamic/ImageContent";
import useAuth from "../../hooks/useAuth";
import { useMemo, useState } from "react";

const Suggestion = ({ suggestion, filterTags, setFilterTags }) => {
  const { t } = useTranslation();
  const { username } = useAuth();

  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [areTagsExpanded, setAreTagsExpanded] = useState(false);

  const isCardExpanded = isDescriptionExpanded || areTagsExpanded;

  const tags = useMemo(() => {
    return Array.isArray(suggestion?.tags) ? suggestion.tags.filter(Boolean) : [];
  }, [suggestion?.tags]);

  const maxTagsVisible = 3;
  const visibleTags = areTagsExpanded ? tags : tags.slice(0, maxTagsVisible);
  const hiddenTagsCount = Math.max(0, tags.length - visibleTags.length);

  const introText = String(suggestion?.intro || "");
  const maxIntroChars = 140;
  const shouldTruncateIntro = introText.length > maxIntroChars;
  const displayedIntro =
    !shouldTruncateIntro || isDescriptionExpanded
      ? introText
      : `${introText.slice(0, maxIntroChars).trim()}…`;

  const handleTagToggle = (tag) => {
    if (filterTags.includes(tag)) {
      setFilterTags(filterTags.filter((item) => item !== tag));
    } else {
      setFilterTags((filterTags) => [...filterTags, tag]);
    }
  };

  return (
    <div
      className={`suggestion-container-new${isCardExpanded ? " expanded" : ""}`}
    >
      <div className="new-suggestion-card" key={suggestion.id}>
        <ImageContent
          username={username}
          title={"suggestions_" + suggestion?.id}
          type="image-suggestions"
          smallEditButton={true}
          showEditButton={false}
          showPlaceholder={false}
        />
        <div className="suggestion-des">
          <h3>{suggestion?.title}</h3>

          {Boolean(displayedIntro) && (
            <p className="suggestion-intro">{displayedIntro}</p>
          )}

          {shouldTruncateIntro && (
            <button
              type="button"
              className="suggestion-readmore"
              onClick={() => setIsDescriptionExpanded((v) => !v)}
            >
              {isDescriptionExpanded ? "Read less" : "Read more…"}
            </button>
          )}

          {suggestion?.address && <p>{suggestion?.address}</p>}
          {suggestion?.tel && <p>{suggestion?.tel}</p>}

          <div className="suggestion-tags-container">
            {visibleTags.map((tag) => (
              <button
                type="button"
                className={filterTags.includes(tag) ? "tag-selected" : "tag"}
                onClick={() => {
                  handleTagToggle(tag);
                }}
                key={tag}
              >
                {tag}
              </button>
            ))}

            {(hiddenTagsCount > 0 || (areTagsExpanded && tags.length > maxTagsVisible)) && (
              <button
                type="button"
                className="tag tag-more"
                onClick={() => setAreTagsExpanded((v) => !v)}
              >
                {areTagsExpanded ? "-" : `+${hiddenTagsCount}`}
              </button>
            )}
          </div>
        </div>

        {suggestion?.weblink && (
          <div className="button-con">
            <a
              className="website-link"
              href={suggestion?.weblink}
              target="_blank"
              rel="noreferrer"
            >
              {t("suggestions_page.website-tag")}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Suggestion;
